// This import loads the firebase namespace along with all its type information.
import MetricPeriod from './metric-period-model'

export async function load_metricPeriods(): Promise<MetricPeriod[]> {
  throw 'Not implemented'
}

export async function delete_metricPeriod(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_metricPeriod(): Promise<MetricPeriod> {
  throw 'Not implemented'
}
